import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { ErrorPage } from 'containers';
import { getUserFeedItems } from 'modules/user/userfeed';
import { IUserLanguage } from 'models/user/userlanguage';
import { IUserPreferences } from 'models/user/userpreferences';
const { connect } = require('react-redux');
import { IAuthContext, ILanguage } from 'models/common';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { SectionTitle } from 'components';
import { NotificationType } from 'models/enums/notificationtype';
import { INotification } from 'models/notifications/notification';
import { IWardrobeItemListCard } from 'models/wardrobe/wardrobeitemlistcard';
import { IOutfitListItem } from 'models/outfit/outfitlistitem';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { ArticleStatus } from 'models';
import { IItemCardList } from 'models/itemcard';
import { getCardItems, getCardPlaceholders, goToCard } from 'helpers/common';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Likes } from 'redux/modules/user/likes';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { INotificationsAction, INotificationsData } from 'models/notifications/notifications';
const InfiniteScroll = require('react-infinite-scroll-component');

require('./style.css');

interface IProps {
	userFeedData?: INotificationsData;
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	userPreferences?: IUserPreferences;
	baseUrlClient?: string;
	t?: (x: string) => string;
	getUserFeedItems?: (isFirstLoad: boolean) => INotificationsAction;
	goToCard?: (id: string, type: string, target?: string) => any;
	dispatch?: any;
	context?: IAuthContext;
}

interface IItemWithType {
	id: string;
	itemType: string;
	type: NodeType;
}

function getIdFromEntityId(entityId: string): string {
	try {
		return JSON.parse(entityId).id;
	} catch (e) {
		return '';
	}
}

@connect(
	(state: IStore) => ({
		userFeedData: state.userFeed,
		userLanguage: state.userLanguage,
		languageDomainValues: state.domainValues.languages,
		userPreferences: state.userPreferences,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		dispatch,
		getUserFeedItems: (isFirstLoad: boolean) => dispatch(getUserFeedItems(isFirstLoad)),
		goToCard: (id: string, type: string, target?: string) => goToCard(dispatch, id, type, target),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserFeedComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
	}

	public loadMoreData() {
		if (this.props.context && this.props.context.isAuthenticated()) {
			this.props.getUserFeedItems(false);
		}
	}

	private lastLikesCount = 0;
	private getLikes() {
		if (this.props.context && this.props.context.isAuthenticated()) {
			this.lastLikesCount = this.props.userFeedData.items.length;
			this.props.dispatch(
				this.likes.getLikedItems(
					this.props.userFeedData.items.map((notification) => notification.to).filter((e) => e && e.entityId),
				),
			);
		}
	}

	public componentDidMount() {
		this.lastLikesCount = 0;
		if (this.props.context && this.props.context.isAuthenticated()) {
			this.props.getUserFeedItems(true);
		}
		if (this.props.userFeedData && this.props.userFeedData.items && this.props.userFeedData.items.length) {
			this.getLikes();
		}
	}

	public componentDidUpdate() {
		if (
			this.props.userFeedData &&
			this.props.userFeedData.items &&
			this.props.userFeedData.items.length &&
			this.lastLikesCount !== this.props.userFeedData.items.length
		) {
			this.getLikes();
		}
	}

	private likes = new Likes(LikeNodeType.UserFeed);

	private likeItem(type: NodeType, itemId: string) {
		if (type === undefined) {
			return;
		}
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			this.props.dispatch(this.likes.likeItem(itemId, type));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(type: NodeType, itemId: string) {
		if (type === undefined) {
			return;
		}
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			this.props.dispatch(this.likes.unlikeItem(itemId, type));
		} else {
			signinRedirect();
		}
	}

	private createArticleCardItem(item: INotification): (IItemWithType & IArticleListCard) | null {
		if (item.notificationType !== NotificationType.ArticleAdd) {
			return null;
		}
		const to = item.to;
		const from = item.from;
		return {
			...item,
			itemType: 'ArticleItemCard',
			type: NodeType.Article,
			...to,
			id: getIdFromEntityId(to.entityId),
			status: ArticleStatus.Approved,
			addedBy: from.name,
			minutesToRead: 0,
			languageKey: 0,
		};
	}

	private createProductCardItem(item: INotification): (IItemWithType & IProductListItemCard) | null {
		if (item.notificationType !== NotificationType.ProductAdd) {
			return null;
		}
		const to = item.to;
		const from = item.from;
		return {
			...item,
			itemType: 'ProductItemCard',
			type: NodeType.Product,
			...to,
			id: getIdFromEntityId(to.entityId),
			published: true,
			addedBy: from.name,
			shopCurrencyKey: 1,
			shopId: getIdFromEntityId(from.entityId),
		};
	}

	private createWardrobeItemCardItem(item: INotification): (IItemWithType & IWardrobeItemListCard) | null {
		if (item.notificationType !== NotificationType.WardrobeItemAdd) {
			return null;
		}
		const to = item.to;
		const from = item.from;
		return {
			...item,
			itemType: 'WardrobeItemCard',
			type: NodeType.WardrobeItem,
			...to,
			id: getIdFromEntityId(to.entityId),
			userId: getIdFromEntityId(from.entityId),
			published: true,
			addedBy: from.name,
		};
	}

	private createOutfitCardItem(item: INotification): (IItemWithType & IOutfitListItem) | null {
		if (item.notificationType !== NotificationType.OutfitAdd) {
			return null;
		}
		const to = item.to;
		const from = item.from;
		return {
			...item,
			itemType: 'OutfitItemCard',
			type: NodeType.Outfit,
			...to,
			id: getIdFromEntityId(to.entityId),
			userId: getIdFromEntityId(from.entityId),
			published: true,
			addedBy: from.name,
		};
	}

	private getListData(): IItemCardList {
		// const { items, itemsPage } = this.props.userFeedData;
		const items = (this.props.userFeedData.items || [])
			.map((item) => {
				switch (item.notificationType) {
					case NotificationType.ArticleAdd:
						return this.createArticleCardItem(item);
					case NotificationType.ProductAdd:
						return this.createProductCardItem(item);
					case NotificationType.WardrobeItemAdd:
						return this.createWardrobeItemCardItem(item);
					case NotificationType.OutfitAdd:
						return this.createOutfitCardItem(item);
					default:
						return null;
				}
			})
			.filter(Boolean);

		let totalItems = 0;
		try {
			totalItems = this.props.userFeedData.itemsPage.totalItems;
		} catch (e) {
			console.error(e);
		}

		return {
			itemType: '', // takes itemType from each item
			items,
			nextPageItems: Math.min(10, totalItems - items.length),
			goToCard: this.props.goToCard.bind(this),
			likeItem: this.likeItem.bind(this),
			unlikeItem: this.unlikeItem.bind(this),
		};
	}

	public render() {
		const { t, context } = this.props;

		if (!context || !context.isAuthenticated()) {
			return null;
		}

		if (this.props.userFeedData.error) {
			return <ErrorPage {...this.props} message={this.props.userFeedData.message} />;
		}

		const { items, itemsPage } = this.props.userFeedData;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listData = this.getListData();

		let itemsContent: JSX.Element[] = [];
		if (items) {
			itemsContent = getCardItems(listData);
		}
		let infiniteScrollLoader = infiniteScrollProps ? infiniteScrollProps.loader : undefined;
		if (listData.nextPageItems) {
			const placeholders = getCardPlaceholders(listData);
			infiniteScrollLoader = <>{placeholders}</>;
		}

		return (
			<>
				<div className="portalContentWrapper container-fluid landingContainer list-with-title">
					{itemsContent.length ? <SectionTitle variant="black">{t('Community_Wall')}</SectionTitle> : null}
					<InfiniteScroll {...infiniteScrollProps} loader={infiniteScrollLoader} className="user-feed">
						{itemsContent}
					</InfiniteScroll>
				</div>
				<div className="clear" />
			</>
		);
	}
}

const UserFeed = withAuthContext(UserFeedComponent);

export { UserFeed };
